import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInlove = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 46,
	height: 46,
	viewBox: "0 0 46 46",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23 45.4C35.3712 45.4 45.4 35.3712 45.4 23C45.4 10.6288 35.3712 0.599998 23 0.599998C10.6288 0.599998 0.600006 10.6288 0.600006 23C0.600006 35.3712 10.6288 45.4 23 45.4Z",
			fill: "url(#paint0_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M23 45.4C35.3712 45.4 45.4 35.3712 45.4 23C45.4 10.6288 35.3712 0.599998 23 0.599998C10.6288 0.599998 0.600006 10.6288 0.600006 23C0.600006 35.3712 10.6288 45.4 23 45.4Z",
			fill: "url(#paint1_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 45.4C35.3712 45.4 45.4 35.3712 45.4 23C45.4 10.6288 35.3712 0.599998 23 0.599998C10.6288 0.599998 0.600006 10.6288 0.600006 23C0.600006 35.3712 10.6288 45.4 23 45.4Z",
			fill: "url(#paint2_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 45.4C35.3712 45.4 45.4 35.3712 45.4 23C45.4 10.6288 35.3712 0.599998 23 0.599998C10.6288 0.599998 0.600006 10.6288 0.600006 23C0.600006 35.3712 10.6288 45.4 23 45.4Z",
			fill: "url(#paint3_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.4419 30.4481C38.4559 30.3221 38.4699 30.1961 38.4839 30.0841C38.4559 29.6781 38.2039 29.3001 37.7979 29.1601C37.5879 29.0761 37.3639 29.0761 37.1399 29.1321C32.5619 30.4061 27.8019 31.0641 22.9999 31.0641C18.1979 31.0641 13.4379 30.4201 8.85993 29.1321C8.64993 29.0761 8.41193 29.0761 8.20193 29.1601C7.80993 29.3141 7.55793 29.6641 7.51593 30.0701C7.52993 30.2101 7.54393 30.3501 7.57193 30.5041L7.82393 31.5541C7.87993 31.7501 7.94993 31.9601 8.03393 32.1841C9.60193 35.8521 13.6899 42.3061 23.0139 42.3061C32.3239 42.3061 36.4119 35.8381 37.9939 32.1701C38.0639 31.9741 38.1339 31.7921 38.1759 31.6101L38.4419 30.4481Z",
			fill: "url(#paint4_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 41.2841C26.612 41.2841 29.384 40.2481 31.498 38.7781C29.174 37.7001 26.374 37.0001 23 37.0001C19.626 37.0001 16.812 37.7001 14.488 38.7921C16.616 40.2621 19.388 41.2841 23 41.2841Z",
			fill: "url(#paint5_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.1759 31.5681L38.4279 30.4901C38.4559 30.3361 38.4699 30.1961 38.4699 30.0701C38.4419 29.6641 38.1759 29.3141 37.7839 29.1601C37.5739 29.0761 37.3499 29.0761 37.1259 29.1321C32.5479 30.4061 27.7879 31.0641 22.9859 31.0641C18.1839 31.0641 13.424 30.4201 8.84595 29.1321C8.63595 29.0761 8.39795 29.0761 8.18795 29.1601C7.79595 29.3141 7.54395 29.6641 7.50195 30.0701C7.51595 30.1961 7.52995 30.3501 7.54395 30.5041L7.79595 31.5681C7.85195 31.7641 7.92195 31.9741 8.00595 32.1841C8.63595 33.6681 9.68595 35.6001 11.31 37.3781C9.78395 35.5581 11.66 34.5641 15.034 34.9701C18.394 35.3761 22.9859 35.3901 22.9859 35.3901C22.9859 35.3901 27.5779 35.3761 30.9379 34.9701C34.2979 34.5641 36.1879 35.5721 34.6619 37.3781C36.2999 35.6001 37.3359 33.6681 37.9659 32.1841C38.0499 31.9601 38.1199 31.7641 38.1759 31.5681Z",
			fill: "url(#paint6_linear_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 32.086C18.156 32.086 13.368 31.442 8.73401 30.154L8.79001 30.784C8.90201 31.988 9.78401 32.982 10.96 33.248C14.894 34.116 18.926 34.55 22.986 34.55C27.368 34.55 31.708 34.046 35.936 33.038C36.566 32.884 37.028 32.352 37.098 31.708L37.252 30.168C32.632 31.442 27.844 32.086 23 32.086Z",
			fill: "url(#paint7_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9842 10.05C12.4722 10.736 11.4782 12.108 11.1982 13.62C9.86822 12.822 8.18822 12.654 6.67622 13.34C4.22622 14.446 3.14822 17.33 4.25422 19.766C6.69022 25.156 16.9662 26.36 16.9662 26.36C16.9662 26.36 22.8462 17.862 20.4102 12.458C19.3182 10.036 16.4342 8.94404 13.9842 10.05Z",
			fill: "url(#paint8_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M16.0003 9.61599C20.1723 12.388 20.2283 18.464 18.1983 21.11C15.9583 24.036 13.5923 24.204 8.32834 23.714C12.1503 25.8 16.9663 26.36 16.9663 26.36C16.9663 26.36 22.8463 17.862 20.4103 12.458C19.6123 10.694 17.8483 9.62999 16.0003 9.61599Z",
			fill: "url(#paint9_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M13.9842 10.05C12.4722 10.736 11.4782 12.108 11.1982 13.62C9.86822 12.822 8.18822 12.654 6.67622 13.34C4.22622 14.446 3.14822 17.33 4.25422 19.766C6.69022 25.156 16.9662 26.36 16.9662 26.36C16.9662 26.36 22.8462 17.862 20.4102 12.458C19.3182 10.036 16.4342 8.94404 13.9842 10.05Z",
			fill: "url(#paint10_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M13.9842 10.05C12.4722 10.736 11.4782 12.108 11.1982 13.62C9.86822 12.822 8.18822 12.654 6.67622 13.34C4.22622 14.446 3.14822 17.33 4.25422 19.766C6.69022 25.156 16.9662 26.36 16.9662 26.36C16.9662 26.36 22.8462 17.862 20.4102 12.458C19.3182 10.036 16.4342 8.94404 13.9842 10.05Z",
			fill: "url(#paint11_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .24,
			d: "M10.0502 13.998C10.9602 14.838 10.6242 16.7 9.28018 18.156C7.93618 19.612 6.11618 20.102 5.19218 19.262C4.28218 18.422 4.61818 16.56 5.96218 15.104C7.30618 13.648 9.12618 13.158 10.0502 13.998Z",
			fill: "url(#paint12_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .24,
			d: "M15.0762 10.7082C16.0142 11.1142 16.2522 12.6682 15.5942 14.1802C14.9362 15.6782 13.6482 16.5602 12.6962 16.1542C11.7442 15.7482 11.5202 14.1942 12.1782 12.6822C12.8362 11.1842 14.1242 10.3022 15.0762 10.7082Z",
			fill: "url(#paint13_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .32,
			d: "M14.6003 11.1979C17.1623 10.9459 20.7743 13.2699 19.0383 18.9819C18.0023 22.3979 16.2243 24.6939 13.0183 25.5619C15.2443 26.1779 16.9803 26.3879 16.9803 26.3879C16.9803 26.3879 22.8603 17.8899 20.4243 12.4859C19.3183 10.0359 16.4343 8.9579 13.9983 10.0639C12.4863 10.7499 11.4923 12.1219 11.2123 13.6339C11.2123 13.6339 12.7243 11.3799 14.6003 11.1979Z",
			fill: "url(#paint14_linear_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.6603 13.3261C38.1483 12.6401 36.4543 12.8081 35.1382 13.6201C34.8582 12.0941 33.8643 10.7361 32.3522 10.0501C29.9022 8.95812 27.0322 10.0501 25.9262 12.5001C23.5042 17.8901 29.4262 26.3741 29.4262 26.3741C29.4262 26.3741 39.6883 25.1421 42.1103 19.7381C43.2023 17.3021 42.1103 14.4181 39.6603 13.3261Z",
			fill: "url(#paint15_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M41.3261 14.544C42.0261 19.5 37.5041 23.574 34.1721 23.812C30.4901 24.078 28.8101 22.412 25.6741 18.156C26.6401 22.398 29.4121 26.388 29.4121 26.388C29.4121 26.388 39.6741 25.156 42.0961 19.752C42.9081 17.946 42.5441 15.93 41.3261 14.544Z",
			fill: "url(#paint16_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M39.6603 13.3261C38.1483 12.6401 36.4543 12.8081 35.1382 13.6201C34.8582 12.0941 33.8643 10.7361 32.3522 10.0501C29.9022 8.95812 27.0322 10.0501 25.9262 12.5001C23.5042 17.8901 29.4262 26.3741 29.4262 26.3741C29.4262 26.3741 39.6883 25.1421 42.1103 19.7381C43.2023 17.3021 42.1103 14.4181 39.6603 13.3261Z",
			fill: "url(#paint17_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M39.6603 13.3261C38.1483 12.6401 36.4543 12.8081 35.1382 13.6201C34.8582 12.0941 33.8643 10.7361 32.3522 10.0501C29.9022 8.95812 27.0322 10.0501 25.9262 12.5001C23.5042 17.8901 29.4262 26.3741 29.4262 26.3741C29.4262 26.3741 39.6883 25.1421 42.1103 19.7381C43.2023 17.3021 42.1103 14.4181 39.6603 13.3261Z",
			fill: "url(#paint18_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .24,
			d: "M34.0883 12.9901C34.0603 14.2361 32.4363 15.2161 30.4623 15.1741C28.4883 15.1321 26.9063 14.0961 26.9203 12.8501C26.9483 11.6041 28.5723 10.6241 30.5463 10.6661C32.5343 10.7081 34.1163 11.7441 34.0883 12.9901Z",
			fill: "url(#paint19_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .24,
			d: "M39.8982 14.5721C40.2202 15.5521 39.2122 16.7561 37.6582 17.2601C36.1042 17.7641 34.5782 17.3861 34.2562 16.4061C33.9342 15.4261 34.9422 14.2221 36.4962 13.7181C38.0502 13.2001 39.5762 13.5921 39.8982 14.5721Z",
			fill: "url(#paint20_radial_5_3125)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .32,
			d: "M39.2123 14.5298C41.1023 16.2798 41.7463 20.5218 36.3282 23.0138C33.0802 24.4978 30.1822 24.6938 27.4102 22.8738C28.4182 24.9458 29.4262 26.3878 29.4262 26.3878C29.4262 26.3878 39.6883 25.1558 42.1103 19.7518C43.2023 17.3018 42.1103 14.4318 39.6603 13.3258C38.1483 12.6398 36.4542 12.8078 35.1382 13.6198C35.1382 13.6058 37.8403 13.2558 39.2123 14.5298Z",
			fill: "url(#paint21_linear_5_3125)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(18.5928 13.922) scale(27.0227)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFE030" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFB92E"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(18.5928 13.922) scale(21.26)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFEA5F" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFBC47",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint2_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(10.5649 23.1965) rotate(32.7366) scale(11.8599 8.65641)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						stopColor: "#EB672A",
						stopOpacity: .5
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4286,
						stopColor: "#DC641B",
						stopOpacity: .2846
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .995,
						stopColor: "#C25E00",
						stopOpacity: 0
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint3_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(35.4483 23.1783) rotate(147.263) scale(11.8599 8.65641)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						stopColor: "#EB672A",
						stopOpacity: .5
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4286,
						stopColor: "#DC641B",
						stopOpacity: .2846
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .995,
						stopColor: "#C25E00",
						stopOpacity: 0
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint4_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(22.9977 35.7023) scale(11.9021 11.9021)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#7A4400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint5_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(23.1704 39.6596) scale(9.46967 2.86325)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .2479,
					stopColor: "#FF0000"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C20000"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_5_3125",
				x1: 38.3085,
				y1: 33.2403,
				x2: 7.87755,
				y2: 33.2403,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .00132565,
						stopColor: "#3C2200"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "#512D00"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#3C2200"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint7_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(22.9987 32.3508) scale(26.1048 26.1048)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "white"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#A9BCBE"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint8_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(9.88547 16.8147) rotate(-53.7393) scale(13.8733 11.0036)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .2479,
					stopColor: "#FF0000"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .8639,
					stopColor: "#C20000"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint9_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(9.84762 15.898) rotate(-53.7394) scale(11.9444 9.47368)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .2479,
					stopColor: "#FF0000"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C20000"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint10_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(9.88547 16.8147) rotate(-53.7393) scale(13.8733 11.0036)",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .25
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint11_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(16.3632 19.0804) rotate(-50.6229) scale(10.1264 5.00315)",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#BD2719",
					stopOpacity: .25
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#BD2719",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint12_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(7.61959 16.6519) rotate(-46.0208) scale(3.59972 2.23614)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint13_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(13.8851 13.4471) rotate(-65.0908) scale(2.98035 1.85147)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint14_linear_5_3125",
				x1: 21.2518,
				y1: 31.3865,
				x2: 13.2747,
				y2: 9.57492,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#860805" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#BD2719",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint15_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(31.8448 14.7324) rotate(-5.26571) scale(13.8732 11.0038)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .2479,
					stopColor: "#FF0000"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .8639,
					stopColor: "#C20000"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint16_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(32.5058 14.0962) rotate(-5.26571) scale(11.9443 9.47388)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .2479,
					stopColor: "#FF0000"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C20000"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint17_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(31.8448 14.7324) rotate(-5.26571) scale(13.8732 11.0038)",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .25
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint18_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(34.4692 21.0675) rotate(-2.1516) scale(10.1266 5.00322)",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#BD2719",
					stopOpacity: .25
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#BD2719",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint19_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(30.5116 12.9368) rotate(2.44968) scale(3.59978 2.23638)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint20_radial_5_3125",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(37.0961 15.4782) rotate(-16.6196) scale(2.98044 1.8515)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint21_linear_5_3125",
				x1: 28.5148,
				y1: 32.9002,
				x2: 39.5548,
				y2: 12.4687,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#860805" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#BD2719",
					stopOpacity: 0
				})]
			})
		] })
	]
});
export { SvgInlove as ReactComponent };
